import { CSSProperties, FC } from 'react';
import { ErrorMessage, Field, FieldInputProps } from 'formik';
import { Textarea } from '@mantine/core';

interface FieldTextAreaProps {
    name: string;
    title: string;
    placeholder?: string;
    required?: boolean;
    size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
    style?: CSSProperties;
    disabled?: boolean;
}

const FieldTextArea: FC<FieldTextAreaProps> = ({
    name,
    title,
    placeholder,
    required,
    size,
    style,
    disabled
}: FieldTextAreaProps) => {
    return (
        <>
            <Field name={name}>
                {({ field }: { field: FieldInputProps<string> }) => (
                    <Textarea
                        label={title + (required ? ' *' : '')}
                        placeholder={placeholder || title}
                        value={field.value || ''}
                        onChange={field.onChange}
                        id={field.name}
                        onBlur={field.onBlur}
                        style={style}
                        size={size}
                        disabled={disabled}
                    />
                )}
            </Field>
            <ErrorMessage name={name}>
                {msg => <span className="required">{msg}</span>}
            </ErrorMessage>
        </>
    );
};

export default FieldTextArea;
